
<div *ngIf="editRoles && accountLaunchMode" class="btn-group btn-group-justified">
   <mat-form-field>
      <mat-select [(value)]="defaultRole">
         <mat-option [value]="editRole" *ngFor="let editRole of editRoles" (click)="launchEditor(editRole)">{{editRole.name}}</mat-option>
      </mat-select>
   </mat-form-field>
 </div>